import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { KeystoneHttpClient } from "../../../keystone-http";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class AuthenticationHttpService {
  constructor(private authHttp: KeystoneHttpClient, private http: HttpClient) {}

  login(phone: string, password: string, status: string): Observable<Object> {
    return this.http.post(this.authHttp.getBaseUrl() + "/login", {
      phone: phone,
      password: password,
      activeRoute: status
    });
  }

  registation(
    phone: string,
    password: string,
    privacy: object,
    status: string
  ): Observable<Object> {
    return this.http.post(this.authHttp.getBaseUrl() + "/register", {
      username: name,
      phone: phone,
      password: password,
      privacyFlags: privacy,
      activeRoute: status
    });
  }

  verificationCode(code: string): Observable<Object> {
    let lowCode = code.toLocaleLowerCase();
    // console.log
    return this.authHttp.post("verification-code", {
      verificationCode: lowCode
    });
  }

  verificationPasswordCode(code: string, phone: string): Observable<Object> {
    let lowCode = code.toLocaleLowerCase();
    return this.authHttp.post(
      "check-password-code",
      {
        verificationCode: lowCode,
        phone: phone
      },
      null,
      false,
      false
    );
  }

  newPassword(id, password): Observable<Object> {
    return this.authHttp.post("new-password", {
      uid: id,
      password: password
    });
  }

  askToSendSMS(): Observable<Object> {
    return this.authHttp.get("verification-code");
  }

  askToSendSMSToRecover(phone): Observable<Object> {
    return this.authHttp.post(
      "recover-password",
      {
        phone: phone
      },
      null,
      false,
      false
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication-http.service.ts